import { ACCOUNT_REQUIREMENTS } from '@identity/domain/types';
import type { AccountRequirement } from '@identity/domain/types';

/**
 * The order in which the invitation wizard shows its requirements. `EMAIL` is first and always
 * arrives met, because the link verified it, so the derivation starts at `PASSWORD` with no
 * special case.
 */
export const INVITATION_STEP_ORDER: readonly AccountRequirement[] = ACCOUNT_REQUIREMENTS;

/**
 * The order of the account verification wizard, and the one the gate derives with.
 *
 * Having the same value as the invitation order is not duplication: they match by product
 * coincidence, and sharing one constant would break one flow the day the other reorders its steps.
 */
export const VERIFY_ACCOUNT_STEP_ORDER: readonly AccountRequirement[] = ACCOUNT_REQUIREMENTS;
